"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const react_1 = __importStar(require("react"));
const modal_styles_1 = require("./modal.styles");
const CloseLight = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@pulse-web-ui/icons/lib/lazy/close-light'))));
exports.Modal = (0, react_1.memo)((0, react_1.forwardRef)(({ submitHandler, children, submitLabel, title, showDialog, desktopWidth, closeHandler, closeIcon = true, dangerouslyBypassScrollLock = false, dangerouslyBypassFocusLock = false, noMargin, fullWidthButton = true, contentRef, onDismiss, modalBgColor, }, ref) => {
    const theme = (0, theme_1.useTheme)();
    return (react_1.default.createElement(modal_styles_1.StyledDialog, { ref: ref, isOpen: showDialog, onDismiss: onDismiss !== null && onDismiss !== void 0 ? onDismiss : closeHandler, dangerouslyBypassScrollLock: dangerouslyBypassScrollLock, dangerouslyBypassFocusLock: dangerouslyBypassFocusLock, modalBgColor: modalBgColor },
        react_1.default.createElement(modal_styles_1.StyledDialogContent, { ref: contentRef, desktopWidth: desktopWidth, noMargin: noMargin, "aria-label": "modal" },
            closeIcon && (react_1.default.createElement(modal_styles_1.StyledCloseIcon, { onClick: closeHandler },
                react_1.default.createElement(react_1.Suspense, { fallback: null },
                    react_1.default.createElement(CloseLight, { width: 24, color: theme.colors.icon.primary })))),
            title && react_1.default.createElement(modal_styles_1.StyledTitle, null, title),
            react_1.default.createElement("div", null, children),
            react_1.default.createElement(modal_styles_1.Footer, null, submitHandler && (react_1.default.createElement(modal_styles_1.ButtonWrapper, null,
                react_1.default.createElement(modal_styles_1.StyledButton, { fullWidth: fullWidthButton, label: submitLabel || 'Отправить', onClick: submitHandler })))))));
}));
